
























































import {
  computed,
  defineComponent,
  reactive,
  ref,
} from '@vue/composition-api';
import _ from 'lodash';

import shipmentListOption from '@/table/sisahygo/shipmentList';
import useSisahygo from '@/useSisahygo';

import getSisahygoShipments from '@/gql/sisahygo/getSisahygoShipments.gql';

const SisahygoList = defineComponent({
  setup() {
    const { statuses } = useSisahygo();

    const forceReload = ref(true);

    /* eslint-disable */
    const filter = reactive({
      order_status: '',
      tracking_no: '',
      trackingInput: '',
      order_header_no: '',
      orderHeaderInput: '',
      from_date: '',
      to_date: '',
    });

    const trackingInput = _.debounce(() => {
      filter.tracking_no = filter.trackingInput;
    }, 500);

    const orderHeaderInput = _.debounce(() => {
      filter.order_header_no = filter.orderHeaderInput;
    }, 500);

    function clearFilter() {
      filter.order_status = '';
      filter.tracking_no = '';
      filter.trackingInput = '';
      filter.order_header_no = '';
      filter.orderHeaderInput = '';
      filter.from_date = '';
      filter.to_date = '';
      forceReload.value = false;
      forceReload.value = true;
    }

    const variables = computed(() => ({
      order_status: filter.order_status || undefined,
      tracking_no: filter.tracking_no || undefined,
      order_header_no: filter.order_header_no || undefined,
      from_date: filter.from_date || undefined,
      to_date: filter.to_date || undefined,
    }));

    const getShipmentsResult = (data: any) => {
      if (!data?.sisahygoShipments) return null;

      const response = data.sisahygoShipments;

      // Transform meta to paginatorInfo format expected by CommonRichTableWithGraphQL
      return {
        data: response.data,
        paginatorInfo: {
          currentPage: response.meta?.current_page || 1,
          perPage: response.meta?.per_page || 50,
          total: response.meta?.total || 0,
          lastPage: response.meta?.last_page || 1,
          count: response.data?.length || 0,
          hasMorePages: (response.meta?.current_page || 1) < (response.meta?.last_page || 1),
        },
      };
    };

    return {
      statuses,
      forceReload,
      filter,
      trackingInput,
      orderHeaderInput,
      clearFilter,
      variables,
      shipmentListOption,
      getSisahygoShipments,
      getShipmentsResult,
    };
  },
});

export default SisahygoList;
